import { Component, ReactNode } from 'react';
import { FieldProps, FormikProps } from 'formik';

export interface RenderProps<Value> {
  value: Value;
  name: string;
  onChange: (value: Value) => void;
  onBlur: () => void;
}

interface FormikExternalProps {
  field: Pick<FieldProps['field'], 'name' | 'value'>;
  form: Pick<FormikProps<any>, 'setFieldValue' | 'setFieldTouched'>;
}

export interface EnhancedComponentProps<ValueType> extends FormikExternalProps {
  onChange?: (value: ValueType) => void;
}

interface Props<ValueType> extends EnhancedComponentProps<ValueType> {
  render: (props: RenderProps<ValueType>) => ReactNode;
}

export class FormikProxy<ValueType> extends Component<Props<ValueType>> {
  public handleChange = (newValue: ValueType) => {
    const { setFieldValue } = this.props.form;
    const { name } = this.props.field;
    const { onChange } = this.props;

    if (onChange) {
      onChange(newValue);
    }

    setFieldValue(name, newValue);
  };

  public handleBlur = () => {
    const { setFieldTouched } = this.props.form;
    const { name } = this.props.field;

    setFieldTouched(name, true);
  };

  public render() {
    const { field } = this.props;
    const value = field.value;
    const name = field.name;

    return this.props.render({
      name,
      value,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
    });
  }
}
try {
    // @ts-ignore
    FormikProxy.displayName = "FormikProxy";
    // @ts-ignore
    FormikProxy.__docgenInfo = { "description": "", "displayName": "FormikProxy", "props": { "render": { "defaultValue": null, "description": "", "name": "render", "required": true, "type": { "name": "(props: RenderProps<ValueType>) => ReactNode" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": false, "type": { "name": "(value: ValueType) => void" } }, "field": { "defaultValue": null, "description": "", "name": "field", "required": true, "type": { "name": "Pick<{ onChange: { (e: ChangeEvent<any>): void; <T = string | ChangeEvent<any>>(field: T): T extends ChangeEvent<any> ? void : (e: string | ChangeEvent<any>) => void; }; onBlur: { ...; }; value: any; name: string; }, \"name\" | \"value\">" } }, "form": { "defaultValue": null, "description": "", "name": "form", "required": true, "type": { "name": "Pick<FormikProps<any>, \"setFieldValue\" | \"setFieldTouched\">" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/inputs/FormikProxy.tsx#FormikProxy"] = { docgenInfo: FormikProxy.__docgenInfo, name: "FormikProxy", path: "src/components/inputs/FormikProxy.tsx#FormikProxy" };
}
catch (__react_docgen_typescript_loader_error) { }